/**
 * Validated environment variables for chaos-ui.
 *
 * Vite exposes `import.meta.env.VITE_*` at build/dev time. Anything not
 * prefixed `VITE_` is stripped from the bundle for safety. We parse here
 * with Zod so missing or mis-typed env vars fail loudly at boot.
 */
import { z } from 'zod';

const envSchema = z.object({
  // Gateway base URL — usually same-origin in production (Caddy proxies
  // /api/* to chaos-gateway), but split out so dev can hit localhost:8100.
  VITE_API_BASE_URL: z.string().min(1).default('/api'),
  // WebSocket base URL — same shape as VITE_API_BASE_URL.
  VITE_WS_BASE_URL: z.string().min(1).default('/ws'),
  // VAPID public key (URL-safe base64) — used to subscribe browsers to
  // Web Push. The matching private key lives in Infisical and is only
  // visible to chaos-openclaw-bridge. Empty string disables push UX in
  // /settings/notifications and surfaces a "not configured" banner.
  VITE_VAPID_PUBLIC_KEY: z.string().default(''),
  // Build mode (set by Vite automatically).
  MODE: z.enum(['development', 'production', 'test']).default('development'),
});

export type Env = z.infer<typeof envSchema>;

export const env: Env = envSchema.parse(import.meta.env);
